import React from "react";
import classnames from "classnames";
import { map, capitalize } from "lodash";

const SideInfo = ({ onClose, open, country, data }) => {
  const infoClasses = classnames("info", { ["info--show"]: open });

  if (!data) return null;
  const { Geography } = data;

  return (
    <aside className={infoClasses} id="info">
      <button id="info__button" className="info__button" onClick={onClose} />
      <h3 className="info__title">{capitalize(country.name)}</h3>
      <div className="info__details">
        <ul className="info__list">
          {map(Geography, (value, key) => {
            if (!value.text) return null;

            return (
              <li className="info__list__item" key={value.text}>
                <span className="info__list__item-title">{key}:</span>
                {value.text}
              </li>
            );
          })}
        </ul>
      </div>
    </aside>
  );
};

export default SideInfo;
